import RemoteTable from "../../../../components/Common/RemoteTable";
import { PropTypes } from "prop-types";
import React from "react";
import styled from "styled-components";
import { withRouter, Link } from "react-router-dom";
import { Row } from "reactstrap";
import { Col, Button } from "reactstrap";

const Rent = ({
  offers,
  getOffers,
  clientId,
  history,
  loading_offer_data,
  permissions,
  rent,
}) => {
  const defaultOrdering = "-status";

  React.useEffect(() => {
    getOffers(
      {
        ...offers,
        is_main: false,
        is_rent: rent,
        page: 1,
        my_client: clientId,
        ordering: defaultOrdering,
      },
      false
    );
  }, []);

  const onClickRow = (e, row) => {
    history.push(`/offers/${row.id}`);
  };

  const onClickAddOffer = () => {
    history.push("/offers/add", {
      client_id: clientId,
      is_rent: rent,
    });
  };

  const legalNameFormatter = (cell, row, label) => {
    return (
      <LegalNameLink
        to={{
          pathname: `/offers/${row.id}`,
          state: { is_rent: rent },
        }}
      >
        {row[label]}
      </LegalNameLink>
    );
  };

  const tableOnChange = data => {
    getOffers(
      {
        ...offers,
        ...data,
        is_main: false,
        is_rent: rent,
        my_client: clientId,
        ordering: data.ordering || offers.ordering || defaultOrdering,
      },
      false
    );
  };

  const statusFormatter = (cell, row) => {
    switch (row?.status) {
      case 0: // archived
        return (
          <span className={`badge bg-secondary font-size-12`}>Archived</span>
        );
      case 1: // active
        return <span className={`badge bg-success font-size-12`}>Active</span>;
      // case 2: // rent
      //   return <span className={`badge bg-info font-size-12`}>Rent</span>;
      case -1: //inactive
        return (
          <span className={`badge bg-warning font-size-12`}>Inactive</span>
        );
      default:
        return <span className={`badge bg-info font-size-12`}>None</span>;
    }
  };

  const columns = [
    {
      dataField: "name",
      text: "Offer name",
      sort: true,
      formatter: (cell, row) => legalNameFormatter(cell, row, "name"),
    },
    // {
    //   dataField: "app_info.name",
    //   text: "App",
    //   sort: true,
    //   formatter: (e, row) => formatterForApp(e, row),
    // },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (e, row) => statusFormatter(e, row),
    },
    {
      dataField: "display_media_source_name",
      text: "Media",
      sort: true,
      formatter: (e, row) =>
        legalNameFormatter(e, row, "display_media_source_name"),
    },
    // {
    //   dataField: "display_os_type",
    //   text: "OS type",
    //   sort: true,
    //   formatter: (e, row) => legalNameFormatter(e, row, "display_os_type"),
    // },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col sm="4">
          <h4 style={{ marginTop: "6px" }}>Rent offers</h4>
        </Col>
        <Col sm="8">
          <div className="text-sm-end">
            {permissions?.add_appoffermodel && (
              <Button
                type="button"
                color="success"
                className="btn-rounded m-0"
                onClick={onClickAddOffer}
              >
                <i className="mdi mdi-plus me-1" /> Add rent offer
              </Button>
            )}
          </div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={12}>

              {offers.results.length !== 0 ? (
                <RemoteTable
                  columns={columns}
                  data={loading_offer_data ? [] : offers}
                  search_input={false}
                  onTableChange={tableOnChange}
                  loading={loading_offer_data}
                />
              ) : (
                <Row className="align-items-center text-center mt-4">
                  <Col xs={12}>
                    <i
                      className="dripicons-archive"
                      style={{ fontSize: "130px", opacity: "0.2" }}
                    />
                    <p style={{ opacity: "0.2" }}>
                      Oops, client has no offers...
                    </p>
                  </Col>
                </Row>
              )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

const LegalNameLink = styled(Link)`
  transition-duration: 0.1s;
  color: #495057;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Rent.propTypes = {
  userId: PropTypes.string,
  history: PropTypes.any,
  loading: PropTypes.bool,
  permissions: PropTypes.any,
  getOffers: PropTypes.func,
  setOffers: PropTypes.func,
  offers: PropTypes.any,
  clientId: PropTypes.any,
  rent: PropTypes.bool,
  loading_offer_data: PropTypes.bool,
};

export default withRouter(Rent);
